import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from "primeng/dynamicdialog";
import { NotifyEmailModifyRequest } from "../NotifyEmailModifyRequest";
import { DataService_MultiStationNotification } from "../data.service";
import { MsNotifyFacilitySelectComponent } from "../ms-notify-facility-select/ms-notify-facility-select.component";

@Component({
	selector: "app-ms-notification-edit",
	templateUrl: "./ms-notification-edit.component.html",
	styleUrls: ["./ms-notification-edit.component.css"],
})
export class MsNotificationEditComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_MultiStationNotification,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.NotifyEmailID = this.dialogConfig.data.NotifyEmailID;
		this.FirstName = this.dialogConfig.data.FirstName;
		this.LastName = this.dialogConfig.data.LastName;
		this.Email = this.dialogConfig.data.Email;
		this.OnBlocked = this.dialogConfig.data.OnBlocked;
		this.OnConfirmedOffender = this.dialogConfig.data.OnConfirmedOffender;
		this.OnNeedsVerification = this.dialogConfig.data.OnNeedsVerification;

		this.loadFacilityData();
	}

	///////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////

	NotifyEmailID: number = -1;

	FirstName: string = "";
	LastName: string = "";
	Email: string = "";
	OnBlocked: boolean = false;
	OnConfirmedOffender: boolean = false;
	OnNeedsVerification: boolean = false;

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedFacilities: any = [];
	lstFacility: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FacilityCD", header: "Code" },
		{ field: "FacilityName", header: "Name" },
	];

	loading: boolean = false;
	Processing: boolean = false;

	errorMessage: any = "";

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////

	loadFacilityData() {
		this.loading = true;

		var result = this.visitorService.NotificationFacilitySelectList(this.NotifyEmailID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////

	onAddFacility() {
		var ref = this.dialogService.open(MsNotifyFacilitySelectComponent, {
			header: "Add Facilities",
			width: "fit-content",
			data: {
				SelectedFacilities: this.lstFacility,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0 && response != undefined) {
				var lstToAdd = response;

				for (var z = 0; z < lstToAdd.length; z++) {
					var toAdd = lstToAdd[z];

					var found = false;
					for (var i = 0; i < this.lstFacility.length; i++) {
						var next = this.lstFacility[i];

						if (toAdd.FacilityID == next.FacilityID) {
							found = true;
						}
					}

					if (!found) {
						this.lstFacility = [...this.lstFacility, toAdd];
					}
				}
			}
		});
	}

	onDeleteFacility() {
		this.lstFacility = this.lstFacility.filter((facility) => this.SelectedFacilities.indexOf(facility) == -1);
		this.SelectedFacilities = [];
	}

	onAdd() {
		this.errorMessage = "";

		if (this.FirstName == "") {
			this.errorMessage = "Enter the person's first name";
			return;
		}
		if (this.LastName == "") {
			this.errorMessage = "Enter the person's last name";
			return;
		}
		if (this.Email == "") {
			this.errorMessage = "Enter the email to send notifications to";
			return;
		}
		if (this.OnBlocked == false && this.OnConfirmedOffender == false && this.OnNeedsVerification == false) {
			this.errorMessage = "Select which type of emails to receive";
			return;
		}

		this.Processing = true;

		var fIDs: number[] = [];

		for (var z = 0; z < this.lstFacility.length; z++) {
			var next = this.lstFacility[z];

			fIDs = [...fIDs, next.FacilityID];
		}

		var parms: NotifyEmailModifyRequest = {
			NotifyEmailID: this.NotifyEmailID,
			Email: this.Email,
			FirstName: this.FirstName,
			LastName: this.LastName,
			OnBlocked: this.OnBlocked == true ? 1 : 0,
			OnConfirmedOffender: this.OnConfirmedOffender == true ? 1 : 0,
			OnNeedsVerification: this.OnNeedsVerification == true ? 1 : 0,
			lstFacilityIDs: fIDs,
		};

		var result = this.visitorService.NotificationUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email was added Successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Email: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////////////
}
